<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Safety Reports</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Safety Reports
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <div class="content-header-right col-md-6 col-12 mb-md-0 mb-2">
                <div class=" float-md-right">
                    <button v-if="safety_report.status === 'pending' || safety_report.status === 'submitted'" @click.prevent="updateStatus('investigating')" type="button" class="btn btn-warning mr-1">
                        <i class="feather icon-check icon-left"></i>
                        Mark as Investigating
                    </button>
                    <button v-if="safety_report.status !== 'resolved'" data-toggle="modal"
                            @click.prevent="resolvedModal"
                            data-target="#resolved-modal"
                            type="button" class="btn btn-outline-primary"
                    >
                        <i class="feather icon-check icon-left"></i>
                        Mark as Resolved
                    </button>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="users-view">
                <div class="card">
                    <div class="card-content">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <h3 class="mb-1"><i class="feather icon-info"></i> Report Details</h3>
                                    <table class="table table-borderless">
                                        <tbody>
                                        <tr>
                                            <td>Report Id:</td>
                                            <td>{{ safety_report.id }}</td>
                                        </tr>
                                        <tr>
                                            <td>Ride Id:</td>
                                            <td>
                                                <a :href="route('admin.trips.show', safety_report.trip_id)">
                                                    {{ safety_report.trip_id }}
                                                </a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Report Type:</td>
                                            <td>{{ safety_report.report_type }}</td>
                                        </tr>
                                        <tr>
                                            <td>Reporter:</td>
                                            <td>{{ safety_report.reporter_type }}</td>
                                        </tr>
                                        <tr>
                                            <td>Issue:</td>
                                            <td>
                                                <b>{{ safety_report.issue_description }}</b>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Evidence files:</td>
                                            <td>
                                                <span v-if="safety_report.evidence_files" class="d-flex justify-content-between">
                                                    <a :href="file" v-for="file in safety_report.evidence_files">
                                                        <img :src="file" style="width: 40px; height: 40px; object-fit: cover; border-radius: 6px;" alt="evidence file">
                                                    </a>
                                                </span>
                                                <span v-else>
                                                    NIL
                                                </span>
                                            </td>
                                        </tr>
                                        <tr v-if="safety_report.report_type === 'Insurance'">
                                            <td>Insurance Id:</td>
                                            <td>
                                                {{ safety_report.trip.insurance_policy_id }}
                                            </td>
                                        </tr>
                                        <tr v-if="safety_report.report_type === 'Insurance'">
                                            <td>Insurance Id:</td>
                                            <td>
                                                {{ safety_report.trip.insurance_policy_no }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Reporter Name:</td>
                                            <td>{{ safety_report.reporter_type === "passenger" ? safety_report.passenger.first_name + " " + safety_report.passenger.last_name : safety_report.driver.first_name + " " + safety_report.driver.last_name }}</td>
                                        </tr>
                                        <tr>
                                            <td>Status:</td>
                                            <td>
                                                <span :class="'users-view-status badge badge-' + statusClass(safety_report.status)"
                                                >
                                                    {{ safety_report.status }}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Resolved at:</td>
                                            <td>
                                                {{ formatDateTime(safety_report.resolved_at) }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Resolution Note:</td>
                                            <td>
                                                {{ safety_report.resolution_notes }}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-12 col-md-6">
                                </div>
                                <div class="col-12 col-md-6 mt-3">
                                    <h3 class="mb-1"><i class="feather icon-info"></i> User Details</h3>

                                    <table class="table table-borderless">
                                        <tbody>
                                        <tr>
                                            <td>User Name:</td>
                                            <td>{{ safety_report.passenger?.first_name + " " + safety_report.passenger?.last_name }}</td>
                                        </tr>
                                        <tr>
                                            <td>User Email:</td>
                                            <td>{{ safety_report.passenger?.email }}</td>
                                        </tr>
                                        <tr>
                                            <td>User Phone:</td>
                                            <td>{{ safety_report.passenger?.phone }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-12 col-md-6 mt-3">
                                    <h3 class="mb-1"><i class="feather icon-info"></i> Driver Details</h3>
                                    <table class="table table-borderless">
                                        <tbody>
                                        <tr>
                                            <td>Driver Name:</td>
                                            <td>{{ safety_report.driver?.first_name + " " + safety_report.driver?.last_name }}</td>
                                        </tr>
                                        <tr>
                                            <td>Driver Email:</td>
                                            <td>{{ safety_report.driver?.email }}</td>
                                        </tr>
                                        <tr>
                                            <td>Driver Phone:</td>
                                            <td>{{ safety_report.driver?.phone }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div class="modal fade resolved-modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
             aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <form @submit.prevent="updateStatus('resolved')">
                        <div class="modal-header">
                            <h4 id="myModalLabel1" class="modal-title">Resolve Issue</h4>
                            <button type="button" data-dismiss="modal" aria-label="Close" class="close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group"><label>Resolution Note</label>
                                <textarea required class="form-control" v-model="safetyReport.resolution_notes">
                                </textarea>
                                <div v-if="errors.resolution_notes" class="text-danger text-small">
                                    {{ errors.resolution_notes }}
                                </div>
                            </div>

                        </div>

                        <div class="modal-footer">
                            <button class="btn btn-primary" :disabled="saving">
                                Submit <i class="fa fa-spinner fa-spin" v-if="saving"/>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
    metaInfo: {title: 'Trip'},
    name: 'TripShow',
    props: ['safety_report'],
    layout: Layout,
    data: () => ({
        saving: false,
        safetyReport: {
            status: null,
            resolution_notes: null,
        },
        errors: {}
    }),
    methods: {
        async updateStatus(value) {
            this.saving = true
            this.safetyReport.status = value
            if (value === "investigating") this.safetyReport.resolution_notes = null

            this.$inertia.put(route('admin.safety-reports.update', this.safety_report.id),
                this.safetyReport, {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.saving = false
                        $('.resolved-modal').modal('hide');
                    },
                    onError: (response) => {
                        this.saving = false
                        this.errors.resolution_notes = response.resolution_notes
                    }
                });
        },
        resolvedModal() {
            $('.resolved-modal').modal('show');
        },
        formatDateTime(value) {
            if (!value) return value

            const date = new Date(value);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
        statusClass(value) {
            if (value === 'pending') {
                return "danger";
            }
            else if (value === 'investigating')
            {
                return "warning";
            } else if (value === 'resolved')
            {
                return "primary";
            }
        },
    },
    mounted() {

    },
}
</script>
